const IntegrationType = {
    Payments: 'Payments',
    OnlineTravelAgencies: 'OnlineTravelAgencies',
    Invoicing: 'Invoicing',
    PowerBI: 'PowerBI',
};

export { IntegrationType };
export default IntegrationType;



// WEBPACK FOOTER //
// ./src/enums/integrationType.js